import React from 'react';
import { Image, ImageEntity } from '@fupa/fupa-uikit';
import { Caption, ClampedLineTitle, ImageContainer, Link, SubNewsWrapper } from 'app/components/topNewsModule/subNews/subNewsStyles';
import { desktopContentWidth, streamModuleBreakpointLarge, streamModuleBreakpointMedium, streamModuleBreakpointSmall } from 'app/styles/media';
export default function SubNews(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(SubNewsWrapper, {
    "data-sentry-element": "SubNewsWrapper",
    "data-sentry-component": "SubNews",
    "data-sentry-source-file": "SubNews.tsx"
  }, /*#__PURE__*/React.createElement(Link, {
    to: data.getLink(),
    "data-sentry-element": "Link",
    "data-sentry-source-file": "SubNews.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "SubNews.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.News,
    src: data.news.image,
    ratio: "1:1",
    sizesHint: "(min-width: ".concat(desktopContentWidth, "px) 216px, (min-width: ").concat(streamModuleBreakpointLarge, "px) 160px, (min-width: ").concat(streamModuleBreakpointMedium, "px) 120px, (min-width: ").concat(streamModuleBreakpointSmall, "px) 110px, 100px}"),
    "data-sentry-element": "Image",
    "data-sentry-source-file": "SubNews.tsx"
  })), /*#__PURE__*/React.createElement(Caption, {
    variant: "caption1",
    "data-sentry-element": "Caption",
    "data-sentry-source-file": "SubNews.tsx"
  }, data.subject), /*#__PURE__*/React.createElement(ClampedLineTitle, {
    "data-sentry-element": "ClampedLineTitle",
    "data-sentry-source-file": "SubNews.tsx"
  }, data.news.title), /*#__PURE__*/React.createElement(Caption, {
    variant: "caption1",
    "data-sentry-element": "Caption",
    "data-sentry-source-file": "SubNews.tsx"
  }, data.formatDateRelative())));
}